<script setup lang="ts">
import { NavigationLinkTabs } from '@shared/ui/menus'

import { useKidDetailMenu } from '../model/kid-detail-menu.hook'

defineOptions({
  name: 'KidDetailMenu',
})

const {
  config,
} = useKidDetailMenu()
</script>

<template>
  <NavigationLinkTabs
    :config="config"
  />
</template>
